import { action, observable, runInAction } from "mobx";
import BaseStore from "./Base.store";
import moment from "moment";
import { createExameDasa } from "../services/ExamesService";

const SEXO = {
  Mae: "F",
  SupostoPai: "M",
};

const SEXO_FILHO = {
  FEMININO: "F",
  MASCULINO: "M"
}

const TIPOS_EXAME = {
  PADRAO: "PADRAO",
  CURVA: "CURVA",
  TESTE_PATERNIDADE: "TESTE_PATERNIDADE",
  SEXAGEM_FETAL: "SEXAGEM_FETAL",
  VOLUME: "VOLUME"
};

const participantes = [
  "Mae","Filho","SupostoPai"
]

const TIPO_PARTICIPANTE = {
  "Mae": "MAE",
  "Filho": "FILHO",
  "SupostoPai": "SUPOSTO PAI"
}

export default class ExamesStore extends BaseStore {
  @observable dadosColeta = {
    sujeitoAtencaoId: null
  };
  @observable exame = {
    tipoExame: null,
    material: null,
    profissionalSolicitante: null,
    amostras: [],
    dataColeta: moment().format("YYYY-MM-DD"),
    observacao: "",
    urgente: false,
    volume: "",
    curvas:[{ tempo: "Basal", minutos: "basal",checked: true ,disabled:true}],
  };
  @observable openModalExames = false;
  @observable isLoading = false;
  @observable errors = [];
  @observable openModalSelecionarExame = false;
  @observable modalAlerta = {
    open: false,
    title: "",
    message: "",
  };
  @observable agendamentoProcedimentoId = null;

  @action closeModalAlerta = () => {
    this.modalAlerta = {
      open: false,
      title: "",
      message: "",
    }
  }

  validarExameCurvaPeriodo = (exame) => {
    return (
      exame?.tipoExame &&
      exame?.dataColeta &&
      exame?.tipoExame?.quantidadeAmostras > 0 &&
      exame?.material?.codigo &&
      exame?.profissionalSolicitante?.id &&
      exame.curvas.length >= 3
    );
  };

  validarCamposPadrao = (exame) => {
    return (
      exame?.tipoExame &&
      exame?.dataColeta &&
      exame?.tipoExame?.quantidadeAmostras > 0 &&
      exame?.material?.codigo &&
      exame?.profissionalSolicitante?.id
    );
  };

  validarCamposTestePaternidade = (exame) => {

    return (
      exame?.tipoExame &&
      exame?.dataColeta &&
      exame?.material?.codigo &&
      exame?.profissionalSolicitante?.id &&
      exame?.nomeColetador &&
      exame?.nomeIdentificador &&
      exame?.nomeFilho &&
      exame?.sexoFilho &&
      exame?.dataNascFilho &&
      exame?.nomeMae &&
      exame?.dataNascMae &&
      exame?.nomeSupostoPai &&
      exame?.dataNascSupostoPai
    );
  };

  validarCamposTesteSexagemFetal = (exame) => {
    return (
      exame?.tipoExame &&
      exame?.dataColeta &&
      exame?.tipoExame?.quantidadeAmostras > 0 &&
      exame?.material?.codigo &&
      exame?.profissionalSolicitante?.id &&
      exame?.dataUltimaMenstruacao &&
      exame?.idadeGestacionalSemanas && 
      exame?.fertilizacaoInVitro
    );
  };

  validarCamposVolume = ()=>{
    return (
      this.exame?.tipoExame &&
      this.exame?.dataColeta &&
      this.exame?.tipoExame?.quantidadeAmostras > 0 &&
      this.exame?.material?.codigo &&
      this.exame?.profissionalSolicitante?.id &&
      this.exame?.volume &&
      this.exame?.volume > 0   
    );
  }

  isFormValid() {
    const validador = {
      [TIPOS_EXAME.PADRAO]: () => this.validarCamposPadrao(this.exame),
      [TIPOS_EXAME.TESTE_PATERNIDADE]: () => this.validarCamposTestePaternidade(this.exame),
      [TIPOS_EXAME.SEXAGEM_FETAL]: () => this.validarCamposTesteSexagemFetal(this.exame),
      [TIPOS_EXAME.CURVA]: () => this.validarExameCurvaPeriodo(this.exame),
      [TIPOS_EXAME.VOLUME]: () => this.validarCamposVolume(this.exame)
    };

    const validator = validador[this.exame?.tipoExame?.tipo];
    return validator ? validator() : false;
  };

  @action changeDadosColeta = (event) => {
    this.dadosColeta = event;
  };

  @action togleOpenModalExames = () => {
    this.openModalExames = !this.openModalExames;
  };

  @action togleOpenModalSelecionarExame = () => {
    this.openModalSelecionarExame = !this.openModalSelecionarExame;
  };

  @action initializeAmostrasCurva = () => {
    this.exame.tipoExame.quantidadeAmostras = curvas.length
  }

  @action openAlertaExame = (codigo) => {
    if (codigo === "HIV4C") {
      this.modalAlerta = {
        open: true,
        title: "Atenção!",
        message:
          "Para realização do exame HIV4C é necessário o envio em tubo primário: TUBO SORO GEL SEPARADOR.",
      };
    }
  };

  @action changeDadosExame = (value, field) => {

    if (field === 'curvas') {
      this.exame = {
        ...this.exame,
        [field]: value,
      };
      return this.exame.tipoExame.quantidadeAmostras = value?.length

    }
    if (field === "quantidadeAmostras") {
      this.exame.tipoExame = value;
    } else if (field === "tipoExame") {
      this.openAlertaExame(value?.codigo)
      this.exame = {
        ...this.exame,
        [field]: value,
        material: {},
        amostras: this.initializeAmostras(value?.tipo),
      };
    } else {
      this.exame = {
        ...this.exame,
        [field]: value,
      };
    }
  };

 @action initializeTestePaternidade = () => {
  runInAction(() => {
    const participantes = Array.from({ length: 3 }, (_, index) => ({
      exameParticipante: {
        nome: "",
        datanasc: "",
        sexo: SEXO[index + 1] || "",
      },
    }));

    this.exame.amostras = {
      exame: participantes,
    };
  });
};

 @action initializeAmostras = (tipoExame) => {
    switch (tipoExame) {
      case TIPOS_EXAME.PADRAO:
        return {};
      default:
        return [];
    }
  };

  getAmostrasFormated = () => {
    const { exame } = this;

    if (!exame?.tipoExame?.tipo) {
      return exame?.amostras;
    }

    switch (exame.tipoExame.tipo) {
      case TIPOS_EXAME.TESTE_PATERNIDADE:
        return this.formatTestePaternidadeAmostras();
      case TIPOS_EXAME.SEXAGEM_FETAL:
        return this.formatTesteSexagemFetal();
      case TIPOS_EXAME.CURVA:
        return this.formatTesteCurva();
       case TIPOS_EXAME.PADRAO:
        return this.formatPadrao();
      case TIPOS_EXAME.VOLUME:
      return this.formatVolume();
      default:
        return exame.amostras;
    }
  };

  formatVolume = () => {
    const exame = this.exame || [];

    const dadosadicionais = `volume=${exame.volume}`

   return {
        descricao: this.exame?.tipoExame?.descricao || "",
        material: this.exame?.material?.codigo || "",
        exames: {
          codigo: this.exame.tipoExame?.codigo || "",
          urgente: this.exame.urgente || false,
          dadosadicionais: dadosadicionais,
        },
      };
  }

  formatTesteCurva = ()=>{
    const exame = this.exame || [];

    const amostra = exame?.curvas.map((item) => {
      return {
        
        material:this.exame.material?.codigo || "",
        descricao:item?.minutos || "",
        exames: {
         codigo: this.exame.tipoExame?.codigo || "",
        },
      };
    });

    return amostra
  }

  formatTestePaternidadeAmostras = () => {
    const exame = this.exame;

    const amostrasExame = participantes.map((item) => {

      return {
        exameParticipante: {
          nome: exame?.[`nome${item}`] || "",
          datanasc: exame?.[`dataNasc${item}`] || "",
          sexo: item === "Filho" ? SEXO_FILHO[exame.sexoFilho?.value] : SEXO[item] || "",
          tipo: TIPO_PARTICIPANTE[item]
        },

      }
    }
    );

    const descricao = this.exame.material?.descricao || "";
    const material = this.exame.material?.codigo || "";
    const codigoExame = this.exame.tipoExame?.codigo || "";

    const exames = amostrasExame.map((item, index) => {
      const exameParticipante = item?.exameParticipante || {};

      return {
        codigo: codigoExame,
        exameParticipante: {
          nome: exameParticipante.nome || "",
          datanasc: moment(exameParticipante.datanasc).format("YYYY-MM-DDT:00:00") || "",
          sexo: exameParticipante.sexo ,
          tipo:exameParticipante.tipo || "",
          nomeColetador: this.exame.nomeColetador || "",
          nomeJuiz: this.exame.nomeJuiz || "",
          nomeIdentificador: this.exame.nomeIdentificador || "",
        },
      };
    });

    return {
      descricao,
      material,
      exames,
    };
  };

  formatPadrao = () => {

    const amostras = {
      material: this.exame.material?.codigo || "",
      descricao: this.exame.tipoExame?.descricao || "",
      exames: {
        codigo: this.exame.tipoExame?.codigo || "",
        urgente: this.exame.urgente || false,
      },
    };

   return amostras
  }

  formatTesteSexagemFetal = () => {
    const exame = this.exame || [];
    try {
      const separator = "@carac#xA;";
      const fertilizacaoInVitroToString = `fertilizacaoInVitro=${exame?.fertilizacaoInVitro?.value}${separator}`;
      const idadeGestacionalSemanas = `idadeGestacionalSemanas=${exame?.idadeGestacionalSemanas}${separator}`;
      const dataUltimaMenstruacao = `dataUltimaMenstruacao=${moment(
        exame?.dataUltimaMenstruacao
      ).format("DD/MM/YYYY")}`;

      const string =
        idadeGestacionalSemanas +
        fertilizacaoInVitroToString +
        dataUltimaMenstruacao;

      return {
        descricao: this.exame?.tipoExame?.descricao || "",
        material: this.exame?.material?.codigo || "",
        exames: {
          codigo: this.exame.tipoExame?.codigo || "",
          dadosadicionais: string,
        },
      };
    } catch (e) {
      console.error(e);
    }
  };

  @action incluirExameDasa = async () => {

    this.isLoading = true;
    try {
      const variables = {
        sujeitoAtencao: {
          id: this.dadosColeta?.sujeitoAtencaoId,
        },
        profissionalSolicitanteId: this.exame?.profissionalSolicitante?.id,
        pedidoSolicitacoes: {
          dataColeta: moment(this.exame?.dataColeta),
          observacao: this.exame?.observacao,
          amostras: this.getAmostrasFormated(),
        },
        exameSolicitado: this.exame.tipoExame,
        agendamentoProcedimentoId:this.agendamentoProcedimentoId
      };

      const response = await createExameDasa(variables);
      return response;
    } catch (error) {
      console.error(error);
      return { error: "Erro ao incluir solicitação!" };
    } finally {
      this.isLoading = false;
    }
  };

  @action clear = () => {
    this.exame = {
      tipoExame: null,
      material: null,
      profissionalSolicitante: null,
      amostras: [],
      dataColeta: moment().format("YYYY-MM-DD"),
      observacao: "",
      urgente: false,
      volume: "",
      curvas:[{ tempo: "Basal", minutos: "basal",checked: true ,disabled:true}],
    };
    this.dadosColeta = null;
    this.openModalExames = false;
    this.errors = [];
  };
}
